<template lang="pug">
    v-timeline-item(
        v-if="renderEvent"
        :color='itemColor'
        :icon='cardIcon'
        fill-dot
    )
        template(v-if="event.eventable_type === 'LlmAssessment'" slot="icon")
            PulseWhiteIcon(:size="24")

        ExpandableCardListItem(
            :color="itemColor"
            :content-right-top="event.friendly_event_timestamp_date"
            :content-right-bottom="event.friendly_event_timestamp_time"
            dense
            :expandable="canRenderCard"
            :is-expanded="event.show_card === true"
            :on-expand="onExpand"
            :title="cardTitle"
        )

            template(v-slot:body)
                v-card-text.white.text--primary(
                    v-if="renderCardBody"
                )
                    v-list.py-0(
                        v-if="event.eventable_type === 'Appointment'"
                        two-line
                    )
                        v-list-item
                            v-list-item-content
                                v-list-item-title.list-item-title-overflow
                                    CopyableText(:text="event.appointment_datetime")
                                v-list-item-subtitle Datetime

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    CopyableText(
                                        v-if="event.appointment_number && event.appointment_number.length > 0"
                                        :text="event.appointment_number"
                                    )
                                    template(v-else) N/a
                                v-list-item-subtitle Number

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    CopyableText(
                                        v-if="vehicleYearMakeModel && vehicleYearMakeModel.length > 0"
                                        :text="vehicleYearMakeModel"
                                    )
                                    template(v-else) N/a
                                v-list-item-subtitle Vehicle

                        v-list-item
                            v-list-item-content
                                v-list-item-title(:class="event.appointment_status | statusClassMatcher") {{ event.appointment_status  | titleize }}
                                v-list-item-subtitle Status

                    v-list.py-0(
                        v-if="event.eventable_type === 'Call'"
                        two-line
                    )
                        template(v-if="event.call_missed_call_purpose && event.call_missed_call_purpose.length > 0")
                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong.text-uppercase.error--text {{ event.call_missed_call_purpose | titleize }}
                                    v-list-item-subtitle Missed Call

                        template(v-else)
                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="event.call_user_full_name && event.call_user_full_name.length > 0") {{ event.call_user_full_name }}
                                        template(v-else) N/a
                                    v-list-item-subtitle Agent


                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="event.call_disposition_description && event.call_disposition_description.length > 0") {{ event.call_disposition_description }}
                                        template(v-else) N/a
                                    v-list-item-subtitle Disposition

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.call_duration > 0") {{ event.call_duration | friendlyDurationFormat }}
                                    template(v-else) N/a
                                v-list-item-subtitle Duration

                        v-list-item(v-if="canListenToRecording")
                            v-list-item-content
                                VolieAudio(
                                    v-if="validRecording"
                                    :file="event.call_recording_url"
                                    color="success"
                                    :downloadable="canDownloadRecording"
                                )
                                v-list-item-title(v-else) No recording available

                    v-list.py-0(
                        v-if="event.eventable_type === 'Email'"
                        two-line
                    )
                        v-list-item
                            v-list-item-content
                                v-list-item-title {{ event.email_subject }}
                                v-list-item-subtitle Subject

                        v-list-item
                            v-list-item-content
                                v-list-item-title {{ displayFrom(event.email_from_address, event.email_from_name) }}
                                v-list-item-subtitle From

                        v-list-item
                            v-list-item-content
                                v-list-item-title {{ event.email_to_recipients }}
                                v-list-item-subtitle To

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.email_cc_recipients && event.email_cc_recipients.length > 0") {{ event.email_cc_recipients }}
                                    template(v-else) N/a
                                v-list-item-subtitle CC

                        v-list-item
                            v-list-item-content
                                v-list-item-title(:class="event.email_last_event | statusClassMatcher")
                                    template(v-if="event.email_last_event && event.email_last_event.length > 0") {{ event.email_last_event  | titleize }}
                                    template(v-else) N/a
                                v-list-item-subtitle Last Event

                        v-list-item(v-if="event.email_user_full_name && event.email_user_full_name.length > 0")
                            v-list-item-content
                                v-list-item-title {{ event.email_user_full_name }}
                                v-list-item-subtitle Sent By

                    v-container(v-else-if="event.eventable_type === 'Message'")
                        | {{ event.message_body }}
                        template(v-if="event.message_user_full_name && event.message_user_full_name.length > 0")
                            br
                            br
                            | Sent by {{ event.message_user_full_name }}

                    
                    template(v-if="event.eventable_type === 'LlmAssessment'")
                        v-list.py-0(
                            two-line
                        )
                            v-list-item.d-flex.flex-column.overview
                                .width-100-percent.d-flex.align-center.overview-inner
                                    FlaggedOrApprovedText(
                                        :scorecardOrLlmAssessment="llmAssessmentObject"
                                        itemType="llm_assessment"
                                    )
                                    template(v-if="hasEscalatedCustomer")
                                        v-tooltip(bottom)
                                            template(v-slot:activator="{ on, attrs }")
                                                v-icon.ml-1(v-bind="attrs" v-on="on" color="error") mdi-fire-alert
                                            span Customer Escalated
                                    template(v-if="hasAppointmentOpportunityStatus")
                                        v-tooltip(bottom)
                                            template(v-slot:activator="{ on, attrs }")
                                                v-icon.ml-1(v-bind="attrs" v-on="on" :color="appointmentOpportunityStatusColor") mdi-hand-coin-outline
                                            span Opportunity: {{ event.llm_assessment_appointment_opportunity_status | titleize }}
                            v-list-item
                                v-list-item-content
                                    v-alert(dense border='left' color="var(--off-white)").mb-0
                                        | {{ event.llm_assessment_summary || 'Summary not available' }}
                            v-list-item(v-if="currentUserIsManagerOrAdmin")
                                v-list-item-content
                                    router-link.btn-link(:to="{ name: 'llm_assessments_show', params: { vid: event.llm_assessment_vid } }" target="_blank")
                                        span.mr-1.text-uppercase View Full Assessment 
                                        v-icon(size="16" color="var(--volie-blue)")
                                            | mdi-open-in-new

                            v-list-item
                                v-list-item-content
                                    v-list-item-title {{ event.llm_assessment_friendly_created_at }}
                                    v-list-item-subtitle Created At
                            v-list-item
                                v-list-item-content
                                    v-list-item-title {{ event.llm_assessment_communication_type | titleize }}
                                    v-list-item-subtitle Communication Type
                            v-list-item
                                v-list-item-content
                                    v-list-item-title {{ event.llm_assessment_campaign_name || 'N/A' }}
                                    v-list-item-subtitle Campaign Name
                            template(v-if="event.llm_assessment_ai_disposition_description && event.llm_assessment_ai_disposition_description.length > 0")
                                v-list-item
                                    v-list-item-content
                                        v-list-item-title {{ event.llm_assessment_ai_disposition_description }}
                                        v-list-item-subtitle Pulse Disposition
                            template(v-if="llmAssessmentAiCommunicationDispositions.length > 0")
                                v-list-item
                                    v-list-item-content
                                        PulseDispositionComparison(
                                            :agent-disposition="event.llm_assessment_agent_disposition_description"
                                            :agent-notes="event.llm_assessment_agent_notes"
                                            :ai-communication-dispositions="llmAssessmentAiCommunicationDispositions"
                                            :conference-vid="event.llm_assessment_conference_vid"
                                            compact
                                        )

                            //- Details (collapsible)
                            v-expansion-panels
                                v-expansion-panel
                                    v-expansion-panel-header
                                        v-list-item-content
                                            v-list-item-title Details
                                    v-expansion-panel-content
                                        template(v-if="event.llm_assessment_customer_sentiment && event.llm_assessment_customer_sentiment.length > 0")
                                            v-list-item
                                                v-list-item-content
                                                    .d-flex.align-center
                                                        v-list-item-title Customer Sentiment
                                                        template(v-if="event.llm_assessment_customer_sentiment_score > 0")
                                                            v-progress-circular(
                                                                :value="sentimentScore"
                                                                :color="scoreColor" 
                                                                :rotate="-90"
                                                                :size="36"
                                                            )
                                                                | {{ sentimentScore }}%
                                                    v-alert(dense border='left' color="var(--off-white)").mb-0.mt-1
                                                        | {{ event.llm_assessment_customer_sentiment }}
                                        template(v-if="promises.length > 0")
                                            v-list-item
                                                v-list-item-content
                                                    v-list-item-subtitle Promises
                                                    ol
                                                        li.my-1(v-for="promise in promises") {{ promise }}
                                        template(v-if="hasEscalatedCustomer")
                                            v-divider
                                            v-list-item
                                                v-list-item-content
                                                    v-list-item-title Customer Exclamations
                                                    v-alert(dense border='left' color="var(--off-white)").mb-0.mt-1
                                                        | {{ event.llm_assessment_customer_exclamations }}
                                            v-list-item
                                                v-list-item-content
                                                    v-list-item-title Customer History
                                                    v-alert(dense border='left' color="var(--off-white)").mb-0.mt-1
                                                        | {{ event.llm_assessment_customer_history_short }}

                    template(v-if="event.eventable_type === 'Prospect'")
                        v-list.py-0(
                            two-line
                        )
                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="event.prospect_lead_key && event.prospect_lead_key.length > 0") {{ event.prospect_lead_key }}
                                        template(v-else) N/a
                                    v-list-item-subtitle Lead Key

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="event.prospect_lead_source && event.prospect_lead_source.length > 0") {{ event.prospect_lead_source }}
                                        template(v-else) N/a
                                    v-list-item-subtitle Lead Source

                            v-list-item
                                v-list-item-content
                                    v-list-item-title {{ event.prospect_friendly_request_date }}
                                    v-list-item-subtitle Request Date

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong.text-uppercase(v-if="event.prospect_current_lead_status && event.prospect_current_lead_status.length > 0" :class="event.prospect_current_lead_status | statusClassMatcher") {{ event.prospect_current_lead_status }}
                                        template(v-else) N/a
                                    v-list-item-subtitle Current Status

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="event.prospect_vehicles_interest && event.prospect_vehicles_interest.length > 0") {{ event.prospect_vehicles_interest }}
                                        template(v-else) None
                                    v-list-item-subtitle Vehicle of Interest

                        //- p.mx-4(v-if="event.prospect_comments && event.prospect_comments.length > 0") {{ event.prospect_comments }}

                    v-list.py-0(
                        v-if="event.eventable_type === 'Sale'"
                        two-line
                    )
                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.sale_friendly_deal_book_date && event.sale_friendly_deal_book_date.length > 0") {{ event.sale_friendly_deal_book_date }}
                                    template(v-else) N/a
                                v-list-item-subtitle Deal Book Date

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.sale_deal_number && event.sale_deal_number.length > 0") {{ event.sale_deal_number }}
                                    template(v-else) N/a
                                v-list-item-subtitle Deal #

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.sale_deal_type && event.sale_deal_type.length > 0") {{ event.sale_deal_type | titilize }}
                                    template(v-else) N/a
                                v-list-item-subtitle Deal Type

                        v-list-item(v-if="event.sale_term > 1")
                            v-list-item-content
                                v-list-item-title {{ event.sale_term | number }}
                                v-list-item-subtitle Term

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.sale_salesman_one_name && event.sale_salesman_one_name.length > 0") {{ event.sale_salesman_one_name }}
                                    template(v-else) N/a
                                v-list-item-subtitle Salesman

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    CopyableText(
                                        v-if="vehicleYearMakeModel && vehicleYearMakeModel.length > 0"
                                        :text="vehicleYearMakeModel"
                                    )
                                    template(v-else) N/a
                                v-list-item-subtitle Vehicle

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    CopyableText(
                                        v-if="vehicleVin && vehicleVin.length > 0"
                                        :text="vehicleVin"
                                    )
                                    template(v-else) N/a
                                v-list-item-subtitle VIN

                    v-list.py-0(
                        v-if="event.eventable_type === 'Service'"
                        two-line
                    )
                        v-list-item(v-if="event.service_friendly_open_date && event.service_friendly_open_date.length > 0")
                            v-list-item-content
                                v-list-item-title {{ event.service_friendly_open_date }}
                                v-list-item-subtitle Open Date

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.service_friendly_close_date && event.service_friendly_close_date.length > 0") {{ event.service_friendly_close_date }}
                                    template(v-else) N/a
                                v-list-item-subtitle Close Date

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.service_ro_number && event.service_ro_number.length > 0") {{ event.service_ro_number }}
                                    template(v-else) N/a
                                v-list-item-subtitle RO #

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="event.service_advisor_name && event.service_advisor_name.length > 0") {{ event.service_advisor_name }}
                                    template(v-else) N/a
                                v-list-item-subtitle Service Advisor

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    CopyableText(
                                        v-if="vehicleYearMakeModel && vehicleYearMakeModel.length > 0"
                                        :text="vehicleYearMakeModel"
                                    )
                                    template(v-else) N/a
                                v-list-item-subtitle Vehicle

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    CopyableText(
                                        v-if="vehicleVin && vehicleVin.length > 0"
                                        :text="vehicleVin"
                                    )
                                    template(v-else) N/a
                                v-list-item-subtitle VIN

                        v-list-item
                            v-list-item-content
                                v-list-item-title
                                    template(v-if="odometerOut && odometerOut > 0") {{ odometerOut | number }}
                                    template(v-else) N/a
                                v-list-item-subtitle Odometer

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import CopyableText from '@/components/shared/copyable_text.vue';
    import ExpandableCardListItem from '@/components/shared/expandable_card_list_item.vue';
    import FlaggedOrApprovedText from '@/components/shared/pulse/flagged_or_approved_text.vue';
    import PulseDispositionComparison from '@/components/shared/pulse/pulse_disposition_comparison.vue';
    import PulseWhiteIcon from '@/components/scorecards/pulse_white_icon.vue';
    import VolieAudio from '@/components/shared/audio_player.vue';

    // Helpers
    import { concatVehicleYearMakeModel } from "@/helpers/general";
    import { buildAiCommunicationDispositions } from "@/helpers/pulse";
    import { resourceColorClass, resourceIcon, } from "@/helpers/css_classes";

    // Types
    import { VehicleYearMakeModelObj } from "@/helpers/general";

    export default Vue.extend({
        data() {
            return {
                managerOrAdminRoles: [1, 2, 4, 5, 8],
            }
        },
        methods: {
            displayFrom(fromEmail, fromName) {
                return fromName?.length > 0 ? fromName + " <" + fromEmail + ">" : fromEmail;
            },
            onExpand() {
                if (!this.validEvent) {
                    return;
                }

                this.showClick(this.event);
            },
        },
        computed: {
            appointmentOpportunityStatusColor() {
                if (!this.isEventTypeLlmAssessment) {
                    return 'var(--volie-blue)';
                }

                return this.event?.llm_assessment_appointment_opportunity_status === 'missed' ? 'error' : 'var(--volie-blue)';
            },
            currentUser () {
                return VolieState.currentUser();
            },
            currentUserIsManagerOrAdmin() {
                return this.managerOrAdminRoles.includes(this.currentUser?.activated_role_id || 0);
            },
            canRenderCard() {
                return this.renderEvent && this.event?.eventable_type !== "Customer";
            },
            accountListenRecordingEnabled() {
                return this.currentUser?.account?.communication_center_recordings_listen_enabled === true;
            },
            accountDownloadRecordingEnabled() {
                return this.currentUser?.account?.communication_center_recordings_download_enabled === true;
            },
            canListenToRecording() {
                return this.source !== "communication_center" || (this.source === "communication_center" && this.accountListenRecordingEnabled === true);
            },
            canDownloadRecording() {
                return this.accountDownloadRecordingEnabled && this.canListenToRecording;
            },
            cardIcon() {
                return resourceIcon(this.event?.eventable_type);
            },
            cardTitle() {
                let title = null;
                switch(this.event?.eventable_type) {
                    // case "AdfEmail":
                    //     break;
                    case "Appointment":
                        title = "New Appointment";
                        break;
                    // case "AppointmentImport":
                    //     break;
                    case "Call":
                        switch(this.event?.call_direction) {
                            case "inbound":
                                
                                title = "Inbound Call";
                                break;
                            case "outbound":
                                title = "Outbound Call";
                                break;
                            default:
                                title = "New Call";
                                break;
                        }
                        break;
                    // case "CallBack":
                    //     break;
                    case "CampaignCustomer":
                        break;
                    // case "CampaignProof":
                    //     break;
                    case "Customer":
                        title = "New Customer"
                        break;
                    // case "CustomerImport":
                    //     break;
                    // case "CustomerUpdateImport":
                    //     break;
                    // case "CustomField":
                    //     break;
                    case "Email":
                        switch(this.event?.email_direction) {
                            case "incoming":
                                title = "Incoming Email";
                                break;
                            case "outgoing":
                                title = "Outgoing Email";
                                break;
                            default:
                                title = "New Email";
                                break;
                        }

                        break;
                    case "LlmAssessment":
                        title = "Pulse";
                        break;
                    case "Message":
                        switch(this.event?.message_direction) {
                            case "incoming":
                                // title = "Customer texted in";
                                title = "Incoming Message";
                                break;
                            case "outgoing":
                                // title = (this.event?.message_user_full_name || 'Agent') + " texted customer";
                                title = "Outgoing Message";
                                break;
                            default:
                                title = "New Message";
                                break;
                        }

                        break;
                    case "Prospect":
                        title = "New Lead";
                        break;
                    case "Sale":
                        title = "New Sale";
                        break;
                    // case "SaleImport":
                    //     break;
                    // case "ScheduledCommunication":
                    //     break;
                    case "Service":
                        title = "New Service";
                        break;
                    // case "ServiceImport":
                    //     break;
                    // case "TelematicAlert":
                    //     break;
                    // case "Webhook":
                    //     break;
                    // case "VinMatchImport":
                    //     break;
                }
                return title;
            },
            hasEscalatedCustomer() {
                if (!this.isEventTypeLlmAssessment) {
                    return false;
                }

                return this.event?.llm_assessment_escalated_customer_id && this.event?.llm_assessment_escalated_customer_id > 0;
            },
            hasAppointmentOpportunityStatus() {
                if (!this.isEventTypeLlmAssessment) {
                    return false;
                }

                return this.event?.llm_assessment_appointment_opportunity_status && this.event?.llm_assessment_appointment_opportunity_status !== '';
            },
            itemColor() {
                return resourceColorClass(this.event?.eventable_type);
            },
            isEventTypeLlmAssessment() {
                return this.event.event_type === "llm_assessment" || this.event?.eventable_type === "LlmAssessment";
            },
            llmAssessmentObject() {
                if (!this.isEventTypeLlmAssessment) {
                    return null;
                }

                return {
                    llm_assessment_id: this.event.eventable_id,
                    is_flagged: this.event.llm_assessment_is_flagged,
                };
            },
            llmAssessmentAiCommunicationDispositions() {
                if (!this.isEventTypeLlmAssessment) {
                    return [];
                }

                return buildAiCommunicationDispositions(this.event, {
                    dispositionDescription: "llm_assessment_ai_disposition_description",
                    id: "llm_assessment_ai_communication_disposition_id",
                    notes: "llm_assessment_ai_disposition_notes",
                });
            },
            odometerOut() {
                if (!(this.event?.service_odometer_out?.length > 0)) {
                    return null;
                }

                return parseInt(this.event?.service_odometer_out);
            },
            promises() {
                if (!this.isEventTypeLlmAssessment) {
                    return [];
                }

                const raw = this.event?.llm_assessment_promises;
                if (raw == null || raw === '') {
                    return [];
                }

                // Already an array (e.g. from another code path)
                if (Array.isArray(raw)) {
                    return raw;
                }

                const str = typeof raw === 'string' ? raw.trim() : String(raw);
                if (!str) {
                    return [];
                }

                // Try JSON: array ["a","b"] or object with numeric keys {"0":"a","1":"b"}
                try {
                    const parsed = JSON.parse(str);
                    if (Array.isArray(parsed)) {
                        return parsed;
                    }
                    if (parsed !== null && typeof parsed === 'object') {
                        return Object.values(parsed).filter((v) => typeof v === 'string');
                    }
                } catch {
                    // JSON failed; fall through to PostgreSQL format below (no log yet)
                }

                // PostgreSQL array format: {"item1","item2"} — extract quoted strings
                if (str.startsWith('{') && str.endsWith('}')) {
                    const inner = str.slice(1, -1);
                    const items: string[] = [];
                    const re = /"((?:[^"\\]|\\.)*)"/g;
                    let match;
                    while ((match = re.exec(inner)) !== null) {
                        items.push(match[1].replace(/\\"/g, '"'));
                    }
                    if (items.length > 0) {
                        return items;
                    }
                }

                console.error('Error parsing promises:', str);
                return [];
            },
            renderCardBody() {
                return this.canRenderCard && this.event?.show_card === true;
            },
            renderEvent() {
                return this.validEvent && (this.cardTitle || '') !== ''; // item title switches over the eventables we want to render
            },
            sentimentScore() {
                if (!this.isEventTypeLlmAssessment) {
                    return null;
                }

                return this.event?.llm_assessment_customer_sentiment_score * 100;
            },
            scoreColor() {
                if (!this.isEventTypeLlmAssessment) {
                    return '';
                }

                return this.sentimentScore === null ? '' : this.sentimentScore < 50 ? 'error' : this.sentimentScore < 80 ? 'warning' : 'success';
            },
            validEvent() {
                return this.event?.event_id > 0;
            },
            validRecording() {
                return this.event?.call_recording_url?.length > 0;
            },
            vehicleYearMakeModel() {
                if (!this.validEvent) {
                    return null;
                }

                const vehObj = {
                    vehicleModelYear: this.event.vehicle_model_year,
                    vehicleMake:      this.event.vehicle_make,
                    vehicleModel:     this.event.vehicle_model,
                }

                return concatVehicleYearMakeModel(vehObj as VehicleYearMakeModelObj);
            },
            vehicleVin() {
                return this.event?.vehicle_vin;
            }
        },
        components: {
            CopyableText,
            ExpandableCardListItem,
            FlaggedOrApprovedText,
            PulseDispositionComparison,
            PulseWhiteIcon,
            VolieAudio,
        },
        props: {
            event: Object,
            showClick: Function,
            source: String,
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
p {
    word-break: break-word;
}
.promise-title-wrap {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    word-break: break-word;
}
.overview {
    height: fit-content;
    min-height: 0 !important;

    .overview-inner {
        flex: 0 0 auto;
    }
}
</style>
